/**
 * Determines if an item is positioned fully outside the page boundaries
 *
 * @param x - Item's x position
 * @param y - Item's y position
 * @param width - Item's width
 * @param height - Item's height
 * @param productSize - Product size object with width and height
 * @param padding - Padding object with top, right, bottom, left
 * @param whiteBorder - White border width (if any)
 * @returns true if item is FULLY outside page boundaries (no intersection with valid area)
 */
export const isItemOutsidePageBoundaries = (
  x: number,
  y: number,
  width: number,
  height: number,
  productSize: { width: number; height: number },
  padding?: { top?: number; right?: number; bottom?: number; left?: number },
  whiteBorder?: number,
): boolean => {
  const paddingTop = padding?.top || 0
  const paddingRight = padding?.right || 0
  const paddingBottom = padding?.bottom || 0
  const paddingLeft = padding?.left || 0
  const border = whiteBorder || 0

  // Calculate the valid area boundaries (inside padding and border)
  const validLeft = 0
  const validTop = 0
  const validRight = productSize.width - paddingLeft - paddingRight - border * 2
  const validBottom =
    productSize.height - paddingTop - paddingBottom - border * 2

  // Item boundaries
  const itemLeft = x
  const itemTop = y
  const itemRight = x + width
  const itemBottom = y + height

  // Check if item is FULLY outside valid boundaries (no intersection with valid area)
  const isFullyOutsideLeft = itemRight < validLeft
  const isFullyOutsideTop = itemBottom < validTop
  const isFullyOutsideRight = itemLeft > validRight
  const isFullyOutsideBottom = itemTop > validBottom

  return (
    isFullyOutsideLeft ||
    isFullyOutsideTop ||
    isFullyOutsideRight ||
    isFullyOutsideBottom
  )
}

export default isItemOutsidePageBoundaries
